import _ from "lodash";

const dataStatisticAttestationPartitionFacultyToDrawGraph = function (universityStatistics, date) {
  let series = [];

  const findFacultyStatistics = function(facultyStatistic) {
    console.log(facultyStatistic, date)
    return _.find(facultyStatistic.dateAttestations, (dateAttestation) => {
      return dateAttestation.date === date
    });
  }

   const aggregateDataAttestations = function () {
    _.forEach(universityStatistics, (faculty) => {
      const facultyStatistics = findFacultyStatistics(faculty)

      const seriesDepartment = _.sumBy(facultyStatistics.statisticCourses, (course) => course.attestStudentsPercent);
      const data = ((seriesDepartment/facultyStatistics.statisticCourses.length)/100).toFixed(2)
      series.push(data)
    });
  };

  aggregateDataAttestations();


  return [{
    name: "Статистика вуза",
    data: series
  }];
}

export default dataStatisticAttestationPartitionFacultyToDrawGraph;